import { Plugin } from 'chart.js';

export const VerticalLinePlugin: Plugin = {
  id: 'verticalLine',

  afterDraw(chart, args, options: any) {
    if (!options?.value) return;

    const xScale = chart.scales['x'];
    const ctx = chart.ctx;

    const x = xScale.getPixelForValue(options.value);
    if (isNaN(x)) return;

    ctx.save();
    ctx.beginPath();
    ctx.strokeStyle = options.color || 'red';
    ctx.lineWidth = options.width || 2;
    ctx.moveTo(x, chart.chartArea.top);
    ctx.lineTo(x, chart.chartArea.bottom);
    ctx.stroke();
    ctx.restore();
  }
};
